import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { Route, Switch } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'

import HighValueBasketsIndexPage from '../containers/HighValueBaskets'
import { withAuthorization } from '../containers/Authorization'

import appActions from '../redux/app/actions'

const { changeCurrent } = appActions

const HighValueBasketsIndex = withAuthorization(HighValueBasketsIndexPage, ['super_admin', 'admin'])

const HighValueBasketsPage = ({ location, match }) => {
  const dispatch = useDispatch()
  const current = useSelector(state => state.getIn(['App', 'current'])).toJS()
  const { pathname } = location

  useEffect(() => {
    if (current[0] !== 'high_value_baskets') {
      dispatch(changeCurrent(['high_value_baskets']))
    }
  }, [pathname])

  const path = match.url

  return (
    <Switch>
      <Route path={`${path}/`} component={HighValueBasketsIndex} exact />
    </Switch>
  )
}

HighValueBasketsPage.propTypes = {
  location: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired
}

HighValueBasketsPage.defaultProps = {}

export default HighValueBasketsPage
